import Vue from 'vue'
import Router from 'vue-router'
import wrap from '@/components/wrap'
import Store from '../store'
import { get, post } from './../http'
import { Dialog } from 'vant'
Vue.use(Dialog)

Vue.use(Router)

const routes = [
  // pdf展示
  {
    path: '/pdfShow',
    name: 'pdfShow',
    component: () =>
      import('../components/homePage/pdfShow/pdfShow.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },

  /***
   * ↓↓↓↓↓↓↓↓
   * OA
   * ↓↓↓↓↓↓↓↓
   * **/
  // 会议管理列表页
  {
    path: '/meeting-list',
    name: 'meeting-list',
    component: () =>
      import('../components/oa/meeting-management/meeting-list.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  {
    path: '/leave-management',
    name: 'leave-management',
    component: () =>
      import('../components/oa/leave-manage/leave-manage.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // {
  //   path: '/integrated-menu',
  //   name: 'integrated-menu',
  //   component: () =>
  //     import('../components/oa/integrated-menu.vue'),
  //   meta: {
  //     auth: false,
  //     keepAlive: false,
  //     showTabbar: false
  //   }
  // },
  // //    综合办公 - 请假管理-列表

  // //  综合办公 - 请假管理- 请假管理
  {
    path: '/leave-manage-detail',
    name: 'leave-manage-detail',
    component: () => import('../components/oa/leave-manage/leave-manage-detail.vue'),
    props: route => ({ query: route.query.id }),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  {
    path: '/sales-leave-add',
    name: 'sales-leave-add',
    component: () =>
      import('../components/oa/leave-manage/sales-leave-add'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 请假管理- 销假管理
  {
    path: '/sales-leave-management-detail',
    name: 'sales-leave-management-detail',
    component: () =>
      import('../components/oa/leave-manage/sales-leave-management-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 请假管理- 新增
  {
    path: '/leave-add',
    name: 'leave-add',
    component: () =>
      import('../components/oa/leave-manage/leave-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 人机料管理-请假管理
  {
    path: '/rjl-leave-management',
    name: 'rjl-leave-management',
    component: () =>
      import('../components/oa/rjl-leave-manage/leave-manage.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 人机料-请假申请
  {
    path: '/rjl-leave-add',
    name: 'rjl-leave-add',
    component: () =>
      import('../components/oa/rjl-leave-manage/leave-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 人机料-请假详情
  {
    path: '/rjl-leave-manage-detail',
    name: 'rjl-leave-manage-detail',
    component: () =>
      import('../components/oa/rjl-leave-manage/leave-manage-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 人机料-销假申请
  {
    path: '/rjl-sales-leave-add',
    name: 'rjl-sales-leave-add',
    component: () =>
      import('../components/oa/rjl-leave-manage/sales-leave-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  {
    path: '/rjl-sales-leave-management-detail',
    name: 'rjl-sales-leave-management-detail',
    component: () =>
      import('../components/oa/rjl-leave-manage/sales-leave-management-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 用章管理- 列表
  {
    path: '/chapter-management',
    name: 'chapter-management',
    component: () =>
      import('../components/oa/chapter-management/chapter-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 用章管理-详情
  {
    path: '/chapter-management-detail',
    name: 'chapter-management-detail',
    component: () =>
      import('../components/oa/chapter-management/chapter-management-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //综合办公 - 任务管理-菜单
  {
    path: '/task-menu',
    name: 'task-menu',
    component: () =>
      import('../components/oa/taskmanage/task-menu.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 个人任务管理- 列表
  {
    path: '/task-management',
    name: 'task-management',
    component: () =>
      import('../components/oa/taskmanage/task-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 个人任务管理-新增
  {
    path: '/task-manage-add',
    name: 'task-manage-add',
    component: () =>
      import('../components/oa/taskmanage/task-managem-add/task-management-add'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 个人任务管理-详情
  {
    path: '/task-management-detail',
    name: 'task-management-detail',
    component: () =>
      import('../components/oa/taskmanage/task-management-detail'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 部门任务管理- 列表
  {
    path: '/departmental-task-manage',
    name: '/departmental-task-manage',
    component: () =>
      import('../components/oa/taskmanage/departmental-task/departmental-task-manage'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 部门任务管理-新增
  {
    path: '/departmental-task-add',
    name: 'departmental-task-add',
    component: () =>
      import('../components/oa/taskmanage/departmental-task/departmental-task-add'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 部门任务管理-详情
  {
    path: '/departmental-task-detail',
    name: 'departmental-task-detail',
    component: () =>
      import('../components/oa/taskmanage/departmental-task/departmental-task-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 用章管理- 新增
  {
    path: '/chapter-management-add',
    name: 'chapter-management-add',
    component: () =>
      import('../components/oa/chapter-management/chapter-management-add/chapter-management-add'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 督办通知单 - 列表
  {
    path: '/duban-management',
    name: 'duban-management',
    component: () =>
      import('../components/oa/duban-management/duban-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 督办通知单 - 详情
  {
    path: '/duban-detail',
    name: 'duban-detail',
    component: () =>
      import('../components/oa/duban-management/detail/duban-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 督办通知单 - 新增
  {
    path: '/duban-add',
    name: 'duban-add',
    component: () =>
      import('../components/oa/duban-management/detail/duban-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 公文传阅 - 列表
  {
    path: '/document-circulation',
    name: 'document-circulation',
    component: () =>
      import('../components/oa/document-circulation/document-circulation.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 公文传阅 - 新增
  {
    path: '/document-circulation-add',
    name: 'document-circulation-add',
    component: () =>
      import('../components/oa/document-circulation/detail/document-circulation-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 公文传阅 - 详情
  {
    path: '/document-circulation-detail',
    name: 'document-circulation-detail',
    component: () =>
      import('../components/oa/document-circulation/detail/document-circulation-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 合同审批 - 列表
  {
    path: '/contractInside-management',
    name: 'contractInside-management',
    component: () =>
      import('../components/oa/contractInside-management/contractInside-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 合同审批 - 详情
  {
    path: '/contractInside-detail',
    name: 'contractInside-detail',
    component: () =>
      import('../components/oa/contractInside-management/detail/contractInside-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 合同审批 - 新增
  {
    path: '/contractInside-add',
    name: 'contractInside-add',
    component: () =>
      import('../components/oa/contractInside-management/detail/contractInside-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 班子联席会议 - 列表
  {
    path: '/team-meeting',
    name: 'team-meeting',
    component: () =>
      import('../components/oa/team-meeting/team-meeting.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  {
    path: '/team-meeting-detail',
    name: 'team-meeting-detail',
    component: () =>
      import('../components/oa/team-meeting/detail/team-meeting-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 班子联席会议 - 列表
  {
    path: '/daily-meeting',
    name: 'daily-meeting',
    component: () =>
      import('../components/oa/daily_meeting/daily-meeting.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  {
    path: '/daily-meeting-detail',
    name: 'daily-meeting-detail',
    component: () =>
      import('../components/oa/daily_meeting/detail/daily-meeting-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },

  // // 会议管理 starts
  // //  综合办公 - 会议管理- 周例会- 列表
  {
    path: '/weekly-meetings',
    name: 'weekly-meetings',
    component: () =>
      import('../components/oa/meeting-management/weekly-meetings/weekly-meetings.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 会议管理- 周例会- 新增
  {
    path: '/meeting-add',
    name: 'meeting-add',
    component: () =>
      import('../components/oa/meeting-management/components/meeting-add/metting-add'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 会议管理- 周例会-详情
  {
    path: '/weekly-meetings-detail',
    name: 'weekly-meetings-detail',
    component: () =>
      import('../components/oa/meeting-management/weekly-meetings/weekly-meetings-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 会议管理- 月例会- 列表
  {
    path: '/monthly-meetings',
    name: 'monthly-meetings',
    component: () =>
      import('../components/oa/meeting-management/monthly-meetings/monthly-meetings.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 会议管理- 月例会-详情
  // {
  //   path: '/monthly-meetings-detail',
  //   name: 'monthly-meetings-detail',
  //   component: () =>
  //     import('../components/oa/meeting-management/monthly-meetings/monthly-meetings-detail.vue'),
  //   meta: {
  //     auth: false,
  //     keepAlive: false,
  //     showTabbar: false
  //   }
  // },
  // //  综合办公 - 会议管理- 月例会-新增
  // {
  //   path: '/monthly-meetings-add',
  //   name: 'monthly-meetings-add',
  //   component: () =>
  //     import('../components/oa/meeting-management/monthly-meetings/monthly-meetings-add.vue'),
  //   meta: {
  //     auth: false,
  //     keepAlive: false,
  //     showTabbar: false
  //   }
  // },
  // //  综合办公 - 会议管理- 总经办会议- 列表
  {
    path: '/general-management-meeting',
    name: 'general-management-meeting',
    component: () =>
      import('../components/oa/meeting-management/general-management-meeting/general-management-meeting.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 会议管理- 总经办会议-详情
  // {
  //   path: '/general-management-meeting-detail',
  //   name: 'general-management-meeting-detail',
  //   component: () =>
  //     import('../components/oa/meeting-management/general-management-meeting/general-management-meeting-detail.vue'),
  //   meta: {
  //     auth: false,
  //     keepAlive: false,
  //     showTabbar: false
  //   }
  // },
  // //  综合办公 - 总经办会议- 新增
  // {
  //   path: '/general-management-meeting-add',
  //   name: 'general-management-meeting-add',
  //   component: () =>
  //     import('../components/oa/meeting-management/general-management-meeting/general-management-meeting-add.vue'),
  //   meta: {
  //     auth: false,
  //     keepAlive: false,
  //     showTabbar: false
  //   }
  // },
  // //  综合办公 - 会议管理- 其他会议- 列表
  {
    path: '/other-meetings',
    name: 'other-meetings',
    component: () =>
      import('../components/oa/meeting-management/other-meetings/other-meetings.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 会议管理- 其他会议-详情
  // {
  //   path: '/other-meetings-detail',
  //   name: 'other-meetings-detail',
  //   component: () =>
  //     import('../components/oa/meeting-management/other-meetings/other-meetings-detail.vue'),
  //   meta: {
  //     auth: false,
  //     keepAlive: false,
  //     showTabbar: false
  //   }
  // },
  // //  综合办公 - 会议管理- 其他会议-详情
  // {
  //   path: '/other-meetings-add',
  //   name: 'other-meetings-add',
  //   component: () =>
  //     import('../components/oa/meeting-management/other-meetings/other-meetings-add.vue'),
  //   meta: {
  //     auth: false,
  //     keepAlive: false,
  //     showTabbar: false
  //   }
  // },
  // //  综合办公 - 发文申请
  {
    path: '/dispatch-management',
    name: 'dispatch-management',
    component: () =>
      import('../components/oa/official-document-management/dispatch-management/dispatch-management'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 发文申请详情
  {
    path: '/dispatch-management-detail',
    name: 'dispatch-management-detail',
    component: () =>
      import('../components/oa/official-document-management/dispatch-management/dispatch-management-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 收文管理
  {
    path: '/incoming-management',
    name: 'incoming-management',
    component: () =>
      import('../components/oa/official-document-management/incoming-management/incoming-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 收文管理详情
  {
    path: '/incoming-management-detail',
    name: 'incoming-management-detail',
    component: () =>
      import('../components/oa/official-document-management/incoming-management/incoming-management-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公 - 文件会审
  {
    path: '/document-review',
    name: 'document-review',
    component: () =>
      import('../components/oa/official-document-management/document-review/document-review.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
    // 综合办公 - 文件会审-新增
  {
    path: '/document-review-detail',
    name: 'document-review-detail',
    component: () =>
      import('../components/oa/official-document-management/document-review/detail/document-review-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // //  综合办公 - 用车管理- 列表
  {
    path: '/car-management',
    name: 'car-management',
    component: () =>
      import('../components/oa/car-manage/car-management'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 用车管理-新增
  {
    path: '/car-manage-add',
    name: 'car-manage-add',
    component: () =>
      import('../components/oa/car-manage/car-manage-add/car-management-add'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //  综合办公 - 用车管理-详情
  {
    path: '/car-management-detail',
    name: 'car-management-detail',
    component: () =>
      import('../components/oa/car-manage/car-management-detail'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //综合办公 - 办公用品管理
  {
    path: '/office-management',
    name: 'office-management',
    component: () =>
      import('../components/oa/office-management/office-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //综合办公 - 办公用品管理 - 新增
  {
    path: '/office-management-add',
    name: 'office-management-add',
    component: () =>
      import('../components/oa/office-management/office-management-add/office-management-add'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //综合办公 - 办公用品管理 - 详情
  {
    path: '/office-management-detail',
    name: 'office-management-detail',
    component: () =>
      import('../components/oa/office-management/office-management-detail/office-management-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //综合办公 - 外出管理
  {
    path: '/goOut-management',
    name: 'goOut-management',
    component: () =>
      import('../components/oa/goOut-management/goOut-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //综合办公 - 外出管理 - 新增
  {
    path: '/goOut-management-add',
    name: 'goOut-management-add',
    component: () =>
      import('../components/oa/goOut-management/goOut-management-add/goOut-management-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  //综合办公 - 外出管理 - 详情
  {
    path: '/goOut-management-detail',
    name: 'goOut-management-detail',
    component: () =>
      import('../components/oa/goOut-management/goOut-management-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公-办公用品采购-列表
  {
    path: '/office-procurement-manage',
    name: 'office-procurement-manage',
    component: () =>
      import('../components/oa/office-supplies/procurement/procurement-manage.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公-办公用品采购-新增
  {
    path: '/office-procurement-add',
    name: 'office-procurement-add',
    component: () =>
      import('../components/oa/office-supplies/procurement/procurement-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公-办公用品采购-详情
  {
    path: '/office-procurement-detail',
    name: 'office-procurement-detail',
    component: () =>
      import('../components/oa/office-supplies/procurement/procurement-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公-办公用品申领-列表
  {
    path: '/office-application-manage',
    name: 'office-application-manage',
    component: () =>
      import('../components/oa/office-supplies/application/application-manage.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公-办公用品申请-新增
  {
    path: '/office-application-add',
    name: 'office-application-add',
    component: () =>
      import('../components/oa/office-supplies/application/application-add.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 综合办公-办公用品申请-详情
  {
    path: '/office-application-detail',
    name: 'office-application-detail',
    component: () =>
      import('../components/oa/office-supplies/application/application-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  /** --------------------------------------合同管理开始----------------------------------- */

  // 合同管理-变更初审列表
  {
    path: '/lyrybg-management',
    name: 'lyrybg-management',
    component: () =>
      import('../components/homePage/contract/lyrybg-management/lyrybg-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 合同管理-变更初审详情
  {
    path: '/lyrybg-detail',
    name: 'lyrybg-detail',
    component: () =>
      import('../components/homePage/contract/lyrybg-management/detail/lyrybg-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 合同管理-进场登记列表
  {
    path: '/renyuanjc-management',
    name: 'renyuanjc-management',
    component: () =>
      import('../components/homePage/contract/renyuanjc-management/renyuanjc-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 合同管理-进场登记详情
  {
    path: '/renyuanjc-detail',
    name: 'renyuanjc-detail',
    component: () =>
      import('../components/homePage/contract/renyuanjc-management/detail/renyuanjc-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 合同管理-出场登记列表
  {
    path: '/renyuancc-management',
    name: 'renyuancc-management',
    component: () =>
      import('../components/homePage/contract/renyuancc-management/renyuancc-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 合同管理-进场登记详情
  {
    path: '/renyuancc-detail',
    name: 'renyuancc-detail',
    component: () =>
      import('../components/homePage/contract/renyuancc-management/detail/renyuancc-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 农民工管理-菜单
  {
    path: '/farmerManage-menu',
    name: 'farmerManage-menu',
    component: () =>
      import('../components/homePage/contract/farmerManage/farmerManage-menu.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 农民工人员信息-列表
  {
    path: '/farmer-personInfo',
    name: 'farmer-personInfo',
    component: () =>
      import('../components/homePage/contract/farmerManage/personInfo/personInfo-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 农民工人员信息-详情
  {
    path: '/personInfo-detail',
    name: 'personInfo-detail',
    component: () =>
      import('../components/homePage/contract/farmerManage/personInfo/detail/personInfo-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 工资管理-列表
  {
    path: '/farmer-salaryManage',
    name: 'farmer-salaryManage',
    component: () =>
      import('../components/homePage/contract/farmerManage/salaryManage/salary-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 工资管理-详情
  {
    path: '/salary-detail',
    name: 'salary-detail',
    component: () =>
      import('../components/homePage/contract/farmerManage/salaryManage/detail/salary-detail.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
  // 工资支付台账-列表
  {
    path: '/farmer-paymentAccount',
    name: 'farmer-paymentAccount',
    component: () =>
      import('../components/homePage/contract/farmerManage/paymentAccount/paymentAccount-management.vue'),
    meta: {
      auth: false,
      keepAlive: false,
      showTabbar: false
    }
  },
    // 工资支付台账-详情
    {
      path: '/paymentAccount-detail',
      name: 'paymentAccount-detail',
      component: () =>
        import('../components/homePage/contract/farmerManage/paymentAccount/detail/paymentAccount-detail.vue'),
      meta: {
        auth: false,
        keepAlive: false,
        showTabbar: false
      }
    },
  /** --------------------------------------合同管理结束----------------------------------- */
  /****
   * ↑↑↑↑↑↑↑
   * OA
   * ↑↑↑↑↑↑↑
   * ***/
  {
    path: '/',
    name: 'login',
    component: resolve => require(['../components/login/login'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['../components/login/login'], resolve), meta: { keepAlive: false },

  },
  {
    path: '/SSO',
    name: 'SSO',
    component: resolve => require(['../components/sso/sso'], resolve), meta: { keepAlive: false },

  },
  {
    path: '/showVideo',
    name: 'showVideo',
    component: resolve => require(['../cmscomponents/showVideo/showVideo'], resolve), meta: { keepAlive: false },

  },
  {
    path: '/wrap',
    name: 'wrap',
    component: resolve => require(['../components/wrap'], resolve),
    meta: { keepAlive: false },
    children: [
      /*主页*/
      {
        path: '/homeView',
        name: 'homeView',
        component: () => import('@/components/homePage/homePage.vue'),
        meta: { keepAlive: false },
      },
      /*消息*/
      {
        path: '/message',
        name: 'message',
        component: () => import('@/components/message/message.vue'),
        meta: { keepAlive: true },
      },
      /*协同*/
      {
        path: '/synergy',
        name: 'synergy',
        component: () => import('@/components/synergy/synergy.vue'),
        meta: { keepAlive: false },
      },
      {
        path: '/task-management2',
        name: 'task-management2',
        component: () => import('@/components/oa/taskmanage/task-management.vue'),
        meta: { keepAlive: false },
      },
      /*  最近完工 => 查看更多  */
      // {
      //   path: '/recentlyCompleted',
      //   name:'recentlyCompleted',
      //   component: () => import('@/components/homePage/recentlyCompleted/recentlyCompleted.vue'),
      //   meta: {keepAlive: false},
      // },
      // /*  生产  */
      // {
      //   path: '/ProductionPage',
      //   name:'ProductionPage',
      //   component: () => import('@/components/productionPage/productionPage.vue'),
      //   meta: {keepAlive: false},
      // },
      // /*  施工  */
      // {
      //   path: '/roadworkPage',
      //   name:'roadworkPage',
      //   component: () => import('@/components/roadworkPage/roadworkPage.vue'),
      //   meta: {keepAlive: false},
      // },
      /*  我的  */
      {
        path: '/mePage',
        name: 'mePage',
        component: () => import('@/components/mePage/mePage.vue'),
        meta: { keepAlive: false },
      },
    ]
  },
  /*项目总览*/
  {
    path: '/projectOverview',
    name: 'projectOverview',
    component: () => import('@/components/homePage/projectOverview/projectOverview.vue'),
    meta: { keepAlive: false },
  },
  /*工程日志*/
  {
    path: '/engineeringLogHome',
    name: 'engineeringLogHome',
    component: () => import('@/components/homePage/engineeringLog/engineeringLogHome.vue'),
    meta: { keepAlive: false },
  },

  /*  施工日志*/
  {
    path: '/roadworkLog',
    name: 'roadworkLog',
    component: () => import('@/components/homePage/engineeringLog/roadworkLog/roadworkLog.vue'),
    meta: { keepAlive: false },
  },
  /*施工日志 详情*/
  {
    path: '/roadworkLog-details',
    name: 'roadworkLog-details',
    component: () => import('@/components/homePage/engineeringLog/roadworkLog/roadworkLog-details/roadworkLog-details.vue'),
    meta: { keepAlive: false },
  },
  // 劳务实名
  {
    path: '/labourService',
    name: 'labourService',
    component: () => import('@/components/homePage/labourService/labourService.vue'),
    meta: { keepAlive: false },
  },
  // 劳务实名 列表
  {
    path: '/labourService-list',
    name: 'labourService-list',
    component: () => import('@/components/homePage/labourService/detail/labourService-list.vue'),
    meta: { keepAlive: false },
  },
  // 劳务实名 详情
  {
    path: '/labourService-detail',
    name: 'labourService-detail',
    component: () => import('@/components/homePage/labourService/detail/labourService-detail.vue'),
    meta: { keepAlive: false },
  },
  // 农民工 列表
  {
    path: '/peasantWorker',
    name: 'peasantWorker',
    component: () => import('@/components/homePage/peasantWorker/peasantWorker.vue'),
    meta: { keepAlive: false },
  },
  // 农民工 详情
  {
    path: '/peasantWorker-detail',
    name: 'peasantWorker-detail',
    component: () => import('@/components/homePage/peasantWorker/peasantWorker-detail/peasantWorker-detail.vue'),
    meta: { keepAlive: false },
  },
  // 农民工 列表
  {
    path: '/peasantWorker-list',
    name: 'peasantWorker-list',
    component: () => import('@/components/homePage/peasantWorker/peasantWorker-list/peasantWorker-list.vue'),
    meta: { keepAlive: false },
  },
  // 开工申请 列表
  {
    path: '/startworkManage',
    name: 'startworkManage',
    component: () => import('@/components/homePage/startworkManage/startworkManage.vue'),
    meta: { keepAlive: false },
  },
  // 开工申请 详情
  {
    path: '/startworkManage-detail',
    name: 'startworkManage-detail',
    component: () => import('@/components/homePage/startworkManage/startworkManage-detail/startworkManage-detail.vue'),
    meta: { keepAlive: false },
  },
  // 进场用量与试验情况 列表
  {
    path: '/material-manage',
    name: 'material-manage',
    component: () => import('@/components/homePage/material-manage/material-manage.vue'),
    meta: { keepAlive: false },
  },
  // 进场用量与试验情况 详情
  {
    path: '/materialManage-detail',
    name: 'materialManage-detail',
    component: () => import('@/components/homePage/material-manage/material-manage-detail/material-manage-detail.vue'),
    meta: { keepAlive: false },
  },
  /*安全教育*/
  {
    path: '/safetyEducation',
    name: 'safetyEducation',
    component: () => import('@/components/homePage/safetyEducation/safetyEducation.vue'),
    meta: { keepAlive: false },
  },
  /*安全教育 新增*/
  {
    path: '/safetyEducation-add-details',
    name: 'safetyEducation-add-details',
    component: () => import('@/components/homePage/safetyEducation/safetyEducation-add-details/safetyEducation-add-details.vue'),
    meta: { keepAlive: false },
  },
  /*安全教育 详情*/
  {
    path: '/safetyEducation-details',
    name: 'safetyEducation-details',
    component: () => import('@/components/homePage/safetyEducation/safetyEducation-details/safetyEducation-details.vue'),
    meta: { keepAlive: false },
  },
  /*安全检查*/
  {
    path: '/patrolAbarbeitung',
    name: 'patrolAbarbeitung',
    component: () => import('@/components/homePage/patrolAbarbeitung/patrolAbarbeitung.vue'),
    meta: { keepAlive: false },
  },
  /*安全检查 新增*/
  {
    path: '/patrolAbarbeitung-add-details',
    name: 'patrolAbarbeitung-add-details',
    component: () => import('@/components/homePage/patrolAbarbeitung/patrolAbarbeitung-add-details/patrolAbarbeitung-add-details.vue'),
    meta: { keepAlive: false },
  },
  /*安全检查 详情*/
  {
    path: '/patrolAbarbeitung-details',
    name: 'patrolAbarbeitung-details',
    component: () => import('@/components/homePage/patrolAbarbeitung/patrolAbarbeitung-details/patrolAbarbeitung-details.vue'),
    meta: { keepAlive: false },
  },
  /*进度管理*/
  {
    path: '/scheduleManagement',
    name: 'scheduleManagement',
    component: () => import('@/components/homePage/scheduleManagement/scheduleManagement.vue'),
    meta: { keepAlive: false },
  },
  /*消息详情*/
  {
    path: '/messageDetails',
    name: 'messageDetails',
    component: () => import('@/components/message/message-details/message-details.vue'),
    meta: { keepAlive: false },
  },
  // 质检巡查
  {
    path: '/qualityInspection',
    name: 'qualityInspection',
    component: resolve => require(['../components/qualityInspection/qualityInspection'], resolve),
    meta: { keepAlive: false },
  },

  //  质检巡查 新增
  {
    path: '/qualityInspection-add-details',
    name: 'qualityInspection-add-details',
    component: resolve => require(['../components/qualityInspection/qualityInspection-add-details/qualityInspection-add-details'], resolve),
    meta: { keepAlive: false },
  },
  //  质检巡查  查看
  {
    path: '/qualityInspectionDetails',
    name: 'qualityInspectionDetails',
    component: resolve => require(['../components/qualityInspection/qualityInspection-details/qualityInspection-details'], resolve),
    meta: { keepAlive: false },
  },
  // 质量巡检
  {
    path: '/inspectionManage',
    name: 'inspectionManage',
    component: resolve => require(['../components/homePage/inspectionManage/inspectionManage'], resolve),
    meta: { keepAlive: false },
  },

  //  质量巡检 新增
  {
    path: '/inspectionManage-add',
    name: 'inspectionManage-add',
    component: resolve => require(['../components/homePage/inspectionManage/inspectionManage-add/inspectionManage-add.vue'], resolve),
    meta: { keepAlive: false },
  },
  //  质量巡检  详情页
  {
    path: '/inspectionManage-detail',
    name: 'inspectionManage-detail',
    component: resolve => require(['../components/homePage/inspectionManage/inspectionManage-detail/inspectionManage-detail.vue'], resolve),
    meta: { keepAlive: false },
  },


  //  质检巡查 新增 查看
  {
    path: '/synergy-add-details',
    name: 'synergy-add-details',
    component: resolve => require(['../components/synergy/synergy-add-details/synergy-add-details'], resolve),
    meta: { keepAlive: false },
  },

  /*----------------------------------------------------------------------------------------------------*/

  /*智能考勤*/
  {
    path: '/wisdomAttendance',
    name: 'wisdomAttendance',
    component: () => import('@/components/homePage/wisdomAttendance/wisdomAttendance.vue'),
    meta: { keepAlive: false },
  },
  /*智能考勤 => 日考勤*/
  {
    path: '/dayAttendance',
    name: 'dayAttendance',
    component: () => import('@/components/homePage/wisdomAttendance/dayAttendance/dayAttendance.vue'),
    meta: { keepAlive: false },
  },
  /*  实时监控-菜单  */
  {
    path: '/videoMenu',
    name: 'videoMenu',
    component: () => import('@/components/homePage/videoList/video-menu.vue'),
    meta: { keepAlive: false },
  },
  /*  实时监控  */
  {
    path: '/videoList',
    name: 'videoList',
    component: () => import('@/components/homePage/videoList/videoList.vue'),
    meta: { keepAlive: false },
  },
  /*  实时监控-菜单  */
  {
    path: '/newVideo',
    name: 'newVideo',
    component: () => import('@/components/homePage/videoList/newVideo/newVideo.vue'),
    meta: { keepAlive: false },
  },
  /*  实时监控  */
  {
    path: '/videoList-details',
    name: 'videoList-details',
    component: () => import('@/components/homePage/videoList/videoList-details/videoList-details.vue'),
    meta: { keepAlive: false },
  },
  /*  环境监测  */
  {
    path: '/environmentalMonitoring',
    name: 'environmentalMonitoring',
    component: () => import('@/components/homePage/environmentalMonitoring/environmentalMonitoring.vue'),
    meta: { keepAlive: false },
  },
  /*  环境监测 历史数据 */
  {
    path: '/environmentalMonitoring-details',
    name: 'environmentalMonitoring-details',
    component: () => import('@/components/homePage/environmentalMonitoring/environmentalMonitoring-details/environmentalMonitoring-details.vue'),
    meta: { keepAlive: false },
  },
  /*  万能机  */
  {
    path: '/allCanMachine',
    name: 'allCanMachine',
    component: () => import('@/components/homePage/allCanMachine/allCanMachine.vue'),
    meta: { keepAlive: false },
  },
  /*  万能机详情 */
  {
    path: '/allCanMachine-detail',
    name: 'allCanMachine-detail',
    component: () => import('@/components/homePage/allCanMachine/allCanMachine-detail/allCanMachine-detail.vue'),
    meta: { keepAlive: false },
  },
  /*  压力机  */
  {
    path: '/pressMachine',
    name: 'pressMachine',
    component: () => import('@/components/homePage/pressMachine/pressMachine.vue'),
    meta: { keepAlive: false },
  },
  /*  压力机详情 */
  {
    path: '/pressMachine-detail',
    name: 'pressMachine-detail',
    component: () => import('@/components/homePage/pressMachine/pressMachine-detail/pressMachine-detail.vue'),
    meta: { keepAlive: false },
  },
  /*  恒应力一体机  */
  {
    path: '/aioMachine',
    name: 'aioMachine',
    component: () => import('@/components/homePage/aioMachine/aioMachine.vue'),
    meta: { keepAlive: false },
  },
  /*  恒应力一体机详情 */
  {
    path: '/aioMachine-detail',
    name: 'aioMachine-detail',
    component: () => import('@/components/homePage/aioMachine/aioMachine-detail/aioMachine-detail.vue'),
    meta: { keepAlive: false },
  },
  /*  拌合站  */
  {
    path: '/standManagement',
    name: 'standManagement',
    component: () => import('@/components/homePage/standManagement/standManagement.vue'),
    meta: { keepAlive: true },
  },
  /*  拌合站详情 */
  {
    path: '/standManagement-detail',
    name: 'standManagement-detail',
    component: () => import('@/components/homePage/standManagement/standManagement-detail/standManagement-detail.vue'),
    meta: { keepAlive: false },
  },
  /*  张拉  */
  {
    path: '/pull',
    name: 'pull',
    component: () => import('@/components/homePage/pull/pull.vue'),
    meta: { keepAlive: true },
  },
  /*  张拉详情 */
  {
    path: '/pull-detail',
    name: 'pull-detail',
    component: () => import('@/components/homePage/pull/pull-detail/pull-detail.vue'),
    meta: { keepAlive: false },
  },
  /*  压浆  */
  {
    path: '/press',
    name: 'press',
    component: () => import('@/components/homePage/press/press.vue'),
    meta: { keepAlive: true },
  },
  /*  压浆详情 */
  {
    path: '/press-detail',
    name: 'press-detail',
    component: () => import('@/components/homePage/press/press-detail/press-detail.vue'),
    meta: { keepAlive: false },
  },
  /*  人员定位 */
  {
    path: '/peoplePosition',
    name: 'peoplePosition',
    component: () => import('@/components/homePage/peoplePosition/peoplePosition'),
    meta: { keepAlive: false },
  },
  /*  车辆定位 */
  {
    path: '/carPosition',
    name: 'carPosition',
    component: () => import('@/components/homePage/carPosition/carPosition'),
    meta: { keepAlive: false },
  },
  /*  通知公告 */
  {
    path: '/Notice',
    name: 'Notice',
    component: () => import('@/components/homePage/Notice/Notice'),
    meta: { keepAlive: false },
  },
  /*  通知公告详情页 */
  {
    path: '/Notice-detail',
    name: 'Notice-detail',
    component: () => import('@/components/homePage/Notice/Notice-detail/Notice-detail'),
    meta: { keepAlive: false },
  },
  /*  日进度 */
  {
    path: '/daySchedule',
    name: 'daySchedule',
    component: () => import('@/components/homePage/daySchedule/daySchedule'),
    meta: { keepAlive: false },
  },
  /*  日进度 详情 */
  {
    path: '/daySchedule-detail',
    name: 'daySchedule-detail',
    component: () => import('@/components/homePage/daySchedule/daySchedule-detail/daySchedule-detail'),
    meta: { keepAlive: false },
  },
  /*  周进度 */
  {
    path: '/weekSchedule',
    name: 'weekSchedule',
    component: () => import('@/components/homePage/weekSchedule/weekSchedule'),
    meta: { keepAlive: false },
  },
  /*  周进度 详情 */
  {
    path: '/weekSchedule-detail',
    name: 'weekSchedule-detail',
    component: () => import('@/components/homePage/weekSchedule/weekSchedule-detail/weekSchedule-detail'),
    meta: { keepAlive: false },
  },
  /*  月进度 */
  {
    path: '/monthSchedule',
    name: 'monthSchedule',
    component: () => import('@/components/homePage/monthSchedule/monthSchedule'),
    meta: { keepAlive: false },
  },
  /*  月进度 详情 */
  {
    path: '/monthSchedule-detail',
    name: 'monthSchedule-detail',
    component: () => import('@/components/homePage/monthSchedule/monthSchedule-detail/monthSchedule-detail'),
    meta: { keepAlive: false },
  },
  /*  周进度横屏 */
  {
    path: '/week-transform-page',
    name: 'week-transform-page',
    component: resolve => require(['../cmscomponents/transformPage/week-transformPage'], resolve),
    meta: { keepAlive: false },
  },
  /*  月进度横屏 */
  {
    path: '/month-transform-page',
    name: 'month-transform-page',
    component: resolve => require(['../cmscomponents/transformPage/month-transformPage'], resolve),
    meta: { keepAlive: false },
  },
  /*  安全巡检-列表 */
  {
    path: '/safe-polling',
    name: 'safe-polling',
    component: resolve => require(['../components/homePage/safe-polling/safe-polling'], resolve),
    meta: { keepAlive: false },
  },
  /*  安全巡检-详情页 */
  {
    path: '/safe-polling-detail',
    name: 'safe-polling-detail',
    component: resolve => require(['../components/homePage/safe-polling/safe-polling-detail/safe-polling-detail'], resolve),
    meta: { keepAlive: false },
  },
  /*  安全巡检-新增 */
  {
    path: '/safe-polling-add',
    name: 'safe-polling-add',
    component: resolve => require(['../components/homePage/safe-polling/safe-polling-add/safe-polling-add'], resolve),
    meta: { keepAlive: false },
  },
  //设备清单
  {
    path: '/equipment-list',
    name: 'equipment-list',
    component: resolve => require(['../components/homePage/equipment-group/equipment-list/equipment-list'], resolve),
    meta: { keepAlive: false },
  },
  /*  设备清单-详情页 */
  {
    path: '/equipment-list-detail',
    name: 'equipment-list-detail',
    component: resolve => require(['../components/homePage/equipment-group/equipment-list/equipment-list-detail/equipment-list-detail'], resolve),
    meta: { keepAlive: false },
  },
  //检查、维修
  {
    path: '/check-service',
    name: 'check-service',
    component: resolve => require(['../components/homePage/equipment-group/check-service/check-service'], resolve),
    meta: { keepAlive: false },
  },
  //检查、维修-详情页
  {
    path: '/check-service-detail',
    name: 'check-service-detail',
    component: resolve => require(['../components/homePage/equipment-group/check-service/check-service-detail/check-service-detail'], resolve),
    meta: { keepAlive: false },
  },
  //检查、维修-新增页
  {
    path: '/check-service-add',
    name: 'check-service-add',
    component: resolve => require(['../components/homePage/equipment-group/check-service/check-service-add/check-service-add'], resolve),
    meta: { keepAlive: false },
  },
  //检查、维修-编辑页
  {
    path: '/check-service-edit',
    name: 'check-service-edit',
    component: resolve => require(['../components/homePage/equipment-group/check-service/check-service-add/check-service-edit'], resolve),
    meta: { keepAlive: false },
  },
  //故障、事故
  {
    path: '/fault-accident',
    name: 'fault-accident',
    component: resolve => require(['../components/homePage/equipment-group/fault-accident/fault-accident'], resolve),
    meta: { keepAlive: false },
  },
  //故障、事故-详情页
  {
    path: '/fault-accident-detail',
    name: 'fault-accident-detail',
    component: resolve => require(['../components/homePage/equipment-group/fault-accident/fault-accident-detail/fault-accident-detail'], resolve),
    meta: { keepAlive: false },
  },
  //故障、事故-新增页
  {
    path: '/fault-accident-add',
    name: 'fault-accident-add',
    component: resolve => require(['../components/homePage/equipment-group/fault-accident/fault-accident-add/fault-accident-add'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/projectProgress/list',
    name: 'projectProgressList',
    component: resolve => require(['@/components/homePage/projectProgress/projectProgressList'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/projectProgress/detail',
    name: 'projectProgressDetail',
    component: resolve => require(['@/components/homePage/projectProgress/projectProgressDetail'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/projectProgress/total',
    name: 'projectProgressTotal',
    component: resolve => require(['@/components/homePage/projectProgress/projectProgressTotal'], resolve),
    meta: { keepAlive: false },
  },
  // 人员管理
  {
    path: '/new-personnel',
    name: 'new-personnel',
    component: resolve => require(['@/components/homePage/new-model/new-personnel/new-personnel'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/new-personnel-detail',
    name: 'new-personnel-detail',
    component: resolve => require(['@/components/homePage/new-model/new-personnel/new-personnel-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 设备管理
  {
    path: '/inspection-form',
    name: 'inspection-form',
    component: resolve => require(['@/components/homePage/new-model/inspection-form/inspection-form'], resolve),
    meta: { keepAlive: false },
  },
  // 物料管理
  {
    path: '/materialKc',
    name: 'materialKc',
    component: resolve => require(['@/components/homePage/new-model/materialKc/materialKc'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地列表
  {
    path: '/environment-list',
    name: 'environment-lis',
    component: resolve => require(['@/components/homePage/new-model/envimoni/envimoni-list'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地-环境监测
  {
    path: '/environment',
    name: 'environment',
    component: resolve => require(['@/components/homePage/new-model/envimoni/environment/environment'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地-智能预应力张拉
  {
    path: '/zhangla-manage',
    name: 'zhangla-manage',
    component: resolve => require(['@/components/homePage/new-model/envimoni/zhangla-manage/zhangla-manage'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地-智能预应力张拉
  {
    path: '/pull-detail',
    name: 'pull-detail',
    component: resolve => require(['@/components/homePage/new-model/envimoni/zhangla-manage/pull-detail/pull-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地-智能压浆
  {
    path: '/yajiang-info-manage',
    name: 'yajiang-info-manage',
    component: resolve => require(['@/components/homePage/new-model/envimoni/yajiang-info-manage/yajiang-info-manage'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/press-detail',
    name: 'press-detail',
    component: resolve => require(['@/components/homePage/new-model/envimoni/yajiang-info-manage/press-detail/press-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地-万能机监测
  {
    path: '/all-in-one-monitoring',
    name: 'all-in-one-monitoring',
    component: resolve => require(['@/components/homePage/new-model/envimoni/all-in-one-monitoring/all-in-one-monitoring'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/allCanMachine-detail',
    name: 'allCanMachine-detail',
    component: resolve => require(['@/components/homePage/new-model/envimoni/all-in-one-monitoring/allCanMachine-detail/allCanMachine-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地-压力机监测
  {
    path: '/press-monitoring',
    name: 'press-monitoring',
    component: resolve => require(['@/components/homePage/new-model/envimoni/press-monitoring/press-monitoring'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/pressMachine-detail',
    name: 'pressMachine-detail',
    component: resolve => require(['@/components/homePage/new-model/envimoni/press-monitoring/pressMachine-detail/pressMachine-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地-恒应力一体机监测
  {
    path: '/stress-machine-monitoring',
    name: 'stress-machine-monitoring',
    component: resolve => require(['@/components/homePage/new-model/envimoni/stress-machine-monitoring/stress-machine-monitoring'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/aioMachine-detail',
    name: 'aioMachine-detail',
    component: resolve => require(['@/components/homePage/new-model/envimoni/stress-machine-monitoring/aioMachine-detail/aioMachine-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 智慧工地-拌和站生产管理
  {
    path: '/stand-management',
    name: 'stand-management',
    component: resolve => require(['@/components/homePage/new-model/envimoni/stand-management/stand-management'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/standManagement-detail',
    name: 'standManagement-detail',
    component: resolve => require(['@/components/homePage/new-model/envimoni/stand-management/standManagement-detail/standManagement-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 预制梁场
  {
    path: '/the_prefabricated_field',
    name: 'the_prefabricated_field',
    component: resolve => require(['@/components/homePage/new-model/the_prefabricated_field/the_prefabricated_field'], resolve),
    meta: { keepAlive: false },
  },
  // 征迁管理-三杆迁改
  {
    path: '/rod-line-move',
    name: 'rod-line-move',
    component: resolve => require(['@/components/homePage/new-model/demolitions-manage-wrap/rod-line-move/rod-line-move'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/rod-line-move-detail',
    name: 'rod-line-move-detail',
    component: resolve => require(['@/components/homePage/new-model/demolitions-manage-wrap/rod-line-move/rod-line-move-detail/rod-line-move-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 征迁管理-征地拆迁
  {
    path: '/house-move',
    name: 'house-move',
    component: resolve => require(['@/components/homePage/new-model/demolitions-manage-wrap/house-move/house-move'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/house-move-detail',
    name: 'house-move-detail',
    component: resolve => require(['@/components/homePage/new-model/demolitions-manage-wrap/house-move/house-move-detail/house-move-detail'], resolve),
    meta: { keepAlive: false },
  },
  // 征迁管理-主线土地交付
  {
    path: '/land-delivery',
    name: 'land-delivery',
    component: resolve => require(['@/components/homePage/new-model/demolitions-manage-wrap/land-delivery/land-delivery'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/land-delivery-project',
    name: 'land-delivery-project',
    component: resolve => require(['@/components/homePage/new-model/demolitions-manage-wrap/land-delivery/land-delivery-project/land-delivery-project'], resolve),
    meta: { keepAlive: false },
  },
  {
    path: '/land-delivery-project-detail',
    name: 'land-delivery-project-detail',
    component: resolve => require(['@/components/homePage/new-model/demolitions-manage-wrap/land-delivery/land-delivery-project-detail/land-delivery-project-detail'], resolve),
    meta: { keepAlive: false },
  },
  /*  //故障、事故-编辑
    {
      path: '/fault-accident-edit',
      name:'fault-accident-edit',
      component: resolve => require(['../components/homePage/equipment-group/fault-accident/fault-accident-add/fault-accident-edit'], resolve),
      meta: {keepAlive: false},
    },*/
]

const router = new Router({
  // mode: 'history',
  // base: '/oa/',
  routes: routes
})

router.beforeEach((to, from, next) => {
  /*// router.push({ name: 'login' })
  console.log(JSON.parse(localStorage.getItem('UserMessage')))
  console.log(JSON.parse(localStorage.getItem('loginMessage')))
  // if(Store.getters.getLoginMessage() == null ){
  //  return
  // }
  if(JSON.parse(localStorage.getItem('loginMessage')) !=null&& JSON.parse(localStorage.getItem('loginMessage')).message == '登录成功'&&JSON.parse(localStorage.getItem('UserMessage')) != null){
    post(Store.state.httpHost.login+'/japi/login', {
      username: JSON.parse(localStorage.getItem('UserMessage')).user,
      password: JSON.parse(localStorage.getItem('UserMessage')).pass,
      syscode: 'buss',
    })
      .then(res => {
        console.log('路由登录一次')
        localStorage.setItem('UserMessage', JSON.stringify({
          user:JSON.parse(localStorage.getItem('UserMessage')).user,
          pass:JSON.parse(localStorage.getItem('UserMessage')).pass
        }))
        if (res.data.status === 1) {
          next()
          Store.commit('updateLoginMessage', res.data)
//            // 后台管理的登录信息失效时间
          var hours = 5
          var exp = new Date()
          exp.setTime(exp.getTime() + hours * 60 * 60 * 1000)
          document.cookie =
            'SHARE_JSESSIONID=' +
            Store.getters.getLoginMessage().sessionId +
            ';' +
            'expires=' +
            exp.toGMTString()
//              // 登录成功 跳转首页 homeView
//           this.$notify({ type: 'primary', message: res.data.message});
//            this.$router.push({name: 'homeView'})
        } else {
          // this.$notify(res.data.message)
        }
      })
      .catch(res => {
        next({
          path:'/login'
        })
        console.log(res)
        // this.$notify(res)
      })
  }
  else {
    next()
  }*/
  next()
  // 当跳转路由时关闭所有弹窗
  if (to.path !== from.path) {
    Dialog.close()
  }
  // console.log(to, from)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js